import React, { Component } from 'react';
import WebPay from '../../template/Pay/WebPay';
import { parseQuery } from '../../utils/tools';
import AXIOS from '../../api/axios';
import clientApi from '../../api/client';

const queryObj = parseQuery(window.location.search.slice(1))

class WebPayPage extends Component {
    constructor(){
        super();
        this.state = {
            lessonCnt:'0',
            lessonDate:'',
            userId:queryObj.stuid,
            goodsInfo:[],
            completeRander:false
        }
        this.payTest = this.payTest.bind(this);
    }
    payTest(goodsNo){
        const _this = this;
        AXIOS.payTest({data:{userId:queryObj.stuid,goodsNo:goodsNo}},function(res,err){
            if(err){
                alert(err.errorMessage)
            }else{
                AXIOS.getStuCourse({data:{stuId:queryObj.stuid}},function(res,err){
                    if(err) console.log(err)
                    else{
                        _this.setState({ 
                            lessonCnt : res[0].remainLessonCnt, 
                            lessonDate  : res[0].expireDate
                        })
                    }
                })
                clientApi.payResult()
            }
        })
    }
    getStuCourse(){
        const _this = this;
        AXIOS.getStuCourse({data:{stuId:queryObj.stuid}},function(res,err){
            if(err){
                console.log(err);
            }else{
                _this.setState({ 
                    lessonCnt : res[0].remainLessonCnt, 
                    lessonDate  : res[0].expireDate.replace(/-/g,'.')
                })
            }
        })
    }
    componentDidMount(){
        const _this = this;
        this.getStuCourse()
        setInterval(()=>{
            this.getStuCourse()
        },4000)
        AXIOS.getGoodsInfo({userId:queryObj.stuid},function(res,err){
            if(err) console.log(err)
            else{
                _this.setState({ goodsInfo:res })
                _this.setState({completeRander:true})
            }
        })
    }
    render(){
        return(
            <div className="page_wrap">
                {/* {this.state.goodsInfo.length && <WebPay {...this.state} payTest={this.payTest} />} */}
                <WebPay {...this.state} payTest={this.payTest} />
            </div>
        )
    }
}

export default WebPayPage;



// WEBPACK FOOTER //
// ./src/components/payPage/WebPayPage.jsx